import { ApiService, ApiCacheOptions } from 'src/app/shared';
import { ProfileWidgetDto } from './dto/profile-widget.dto';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileWidgetService {
  constructor(private _apiService: ApiService) {}

  public getProfileWidget(profileId: number): Promise<Array<ProfileWidgetDto>> {
    return this._apiService.get(`profile/${profileId}/ProfileWidget`);
  }

  public updateProfileWidget(widgetId: number,profileWidget: ProfileWidgetDto){
    return this._apiService.put(`ProfileWidget/${widgetId}`, profileWidget);
  }
  public createProfileWidget(profileWidget: ProfileWidgetDto){
    return this._apiService.post(`ProfileWidget`, profileWidget);
  }
  public deleteProfileWidget(widgetId: number): Promise<void> {
    return this._apiService.delete(`ProfileWidget/${widgetId}`);
  }
}
